import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { connect } from 'react-redux';
import View from './View';
import Description from './Description';
import ImgView from './ImgView';
import * as actions from '../../../actions/productData';
import { Feature, Variant } from '../../../refresh/organism/ABFeature';
import DressToolModal from '../../common/DressToolModal';
import DressToolATCModal from '../../common/DressToolATCModal';
import { getEmiDetails } from '../../../refresh/selectors/productpage';
import { getEmiThresholdAmount } from '../../../refresh/selectors/featureFlagsSelector';

class ProductView extends React.Component {

  constructor(props) {
    super(props);
    this.updateIsPlay = this.updateIsPlay.bind(this);
    this.updateTabControl = this.updateTabControl.bind(this);
    this.state = {
      isPlay: true,
      isTabPanelArrowControl: false,
    }
  }

  updateIsPlay(tempIsPlay) {
    try {
      if (this.isPlay !== tempIsPlay)
        this.setState(prevValue => ({ ...prevValue, isPlay: tempIsPlay }))
    } catch (error) {
      console.log(error)
    }
  }

  updateTabControl(tempIsTabPanelArrowControl) {
    this.setState(prevValue => ({ ...prevValue, isTabPanelArrowControl: tempIsTabPanelArrowControl }))
  }

  render() {
    const newDesignLuxe = this.props.newDesignLuxe;
    const productData = this.props.productData;
    let selectedImageId = this.props.selectedImageId;
    let onSelect = this.props.onSelect;
    let viewRender = 'product-page';
    return (
      <Row>
        <Col xs={2}>
          <ImgView
            imgdata={productData}
            selectedImageId={selectedImageId}
            onSelect={onSelect}
            viewRender={viewRender}
            isPlay={this.state.isPlay}
            updateIsPlay={this.updateIsPlay}
            isTabPanelArrowControl={this.state.isTabPanelArrowControl}
            updateTabControl={this.updateTabControl}
          />
        </Col>
        <Col xs={6}>
          <Feature featureName="enable_urgency_driver_pdp">
            <Variant id="0">
              <View
                imgdata={productData}
                selectedImageId={selectedImageId}
                onSelect={onSelect}
                viewRender={viewRender}
                newDesignLuxe={newDesignLuxe}
                isNewProductTag={false}
                isPlay={this.state.isPlay}
                updateIsPlay={this.updateIsPlay}
                isTabPanelArrowControl={this.state.isTabPanelArrowControl}
                emiDetails={this.props.emiDetails}
                emiThresholdAmount={this.props.emiThresholdAmount}
              />
            </Variant>
            <Variant id="1">
              <View
                imgdata={productData}
                selectedImageId={selectedImageId}
                onSelect={onSelect}
                viewRender={viewRender}
                newDesignLuxe={newDesignLuxe}
                isNewProductTag
                isPlay={this.state.isPlay}
                updateIsPlay={this.updateIsPlay}
                isTabPanelArrowControl={this.state.isTabPanelArrowControl}
                emiDetails={this.props.emiDetails}
                emiThresholdAmount={this.props.emiThresholdAmount}
              />
            </Variant>
          </Feature>
        </Col>
        <Col xs={4}>
          <Description
            productData={productData}
            viewRender={viewRender}
            newDesignLuxe={newDesignLuxe}
            openViewMoreEmiModal={this.props.openViewMoreEmiModal}
          />
        </Col>
        <DressToolModal />
        <DressToolATCModal />
      </Row>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedImageId: state.product.selectedImageId,
    emiDetails: getEmiDetails(state),
    emiThresholdAmount: getEmiThresholdAmount(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSelect: productId => dispatch(actions.onSelectById(productId))
  };
};

export default ProductView = connect(mapStateToProps, mapDispatchToProps)(ProductView);
